<template>
  <v-data-table :headers="headers" :items="freecards" :search="search">
    <template v-slot:top>
      <v-row>
        <v-spacer></v-spacer>
        <span class="mr-4">
          <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"></v-text-field>
        </span>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import app from "@/app.js";
export default {
  data() {
    return {
      search: "",
      headers: [
        { text: this.$t("field.dt"), value: "dt", align:"center" },
        { text: this.$t("field.bin"), value: "bin" },
        { text: this.$t("field.system"), value: "system" },
        { text: this.$t("field.ccount"), value: "notcount", align:"center" },
        { text: this.$t("field.acount"), value: "acount", align:"center" },
      ],
      freecards: [],
    };
  },
  async mounted() {
    if (!this.$store.getters["struct/isLoaded"]) {
      await this.$store.dispatch("struct/LOAD_STRUCT");
    }
    app.getFreeCardsCount().then((response) => {
      response.items.forEach((e) => {
        const s = this.$store.getters["struct/systemByBin"](e.bin);
        this.freecards.push({ ...e, system: s ? s.text : "undefined" });
      });
    });
  },
};
</script>

<style>
</style>